import cn from 'classnames'
import Avatar from 'ext-ui/components/Avatar/Avatar'
import { base_colorAction } from 'ext-ui/style/colors'
import React, { ComponentPropsWithRef } from 'react'
import SvgCheckFilled from 'src/components/Svgs/SvgCheckFilled'

import styles from './VendorSelectOption.style'

export type VendorSelectOptionProps = ComponentPropsWithRef<'li'> & {
  name: string
  email?: string
  selected?: boolean
}

/**
 * A single vendor row: leading initial-letter avatar, then the vendor name and
 * email stacked, and a trailing checkmark when the row is the selected vendor.
 * Custom (rather than the base `DropdownOption`) so it can carry the avatar and
 * the two-line identity — the same reason `CreditCardDropdownOption` exists.
 */
const VendorSelectOption = React.forwardRef<
  HTMLLIElement,
  VendorSelectOptionProps
>((props, ref) => {
  const { name, email, selected = false, className, ...rest } = props

  return (
    <li
      ref={ref}
      role={'option'}
      tabIndex={0}
      aria-selected={selected}
      {...rest}
      className={cn('VendorSelectOption', className, { selected })}
      css={styles}
    >
      <Avatar className={'avatar'} fallback={name} size={32} />
      <div className={'option-label-wrapper'}>
        <span className={'ellipsis'}>{name}</span>
        {email && <span className={'option-email ellipsis'}>{email}</span>}
      </div>
      {selected && (
        <span className={'selected-icon'} data-testid={'vendor-option-check'}>
          <SvgCheckFilled fill={base_colorAction} />
        </span>
      )}
    </li>
  )
})

export default VendorSelectOption
